<div class="row password justify-content-center" *ngIf='!passwordtype'>
  <div class="col-11 col-sm-5 col-md-5 col-lg-4 col-xl-3 m-auto">
    <form [formGroup]="firstTimePasswordForm" (ngSubmit)="updatePassword()" method="post" novalidate>
      <h2 class="text-capitalize">Enter New Password</h2>
      <p>First time signed in users must update their password.</p>
      <div class="form-group">
        <mat-form-field appearance="legacy" style="font-size: 15px">
          <mat-label>Password</mat-label>
          <input type="password" matInput formControlName="password" placeholder="Password" name="password"
            [ngClass]="{ 'is-invalid': submitted && newUserFormControls.password.errors }" />
          <mat-error *ngIf="newUserFormControls.password.errors" class="invalid-feedback error">
            <div *ngIf="newUserFormControls.password.errors.required">
              Password is <strong>required</strong>
            </div>
            <div *ngIf="newUserFormControls.password.errors.pattern">
              Password should be at least 8 characters including 1 number, 1 uppercase, 1 lowercase character and 1
              special character.
            </div>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field appearance="legacy" style="font-size: 15px" class="my-5">
          <mat-label>Confirm Password</mat-label>
          <input type="password" matInput formControlName="confirmPassword" placeholder="Confirm Password"
            name="confirmPassword"
            [ngClass]="{ 'is-invalid': submitted && newUserFormControls.confirmPassword.errors }" />
          <mat-error *ngIf="newUserFormControls.confirmPassword.errors" class="invalid-feedback error">
            <div *ngIf="newUserFormControls.confirmPassword.errors.required">
              Confirm Password is <strong>required</strong>
            </div>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <input type="checkbox" formControlName="disclaimer"
          [ngClass]="{ 'is-invalid': submitted && newUserFormControls.disclaimer.errors}" />
        <span>
          By checking this box, I acknowledge that I have read and agree to
          these
          <a href="/assets/data/EULA.pdf" target="_blank">
            Terms of Service and EULA.
          </a>
        </span>
        <div *ngIf="newUserFormControls.disclaimer.errors" class="invalid-feedback error">
          <div *ngIf="newUserFormControls.disclaimer.errors.required">Select the checkbox</div>
        </div>

      </div>

      <div class="form-group my-5">
        <button [disabled]="!firstTimePasswordForm.valid || submitted" mat-raised-button color="accent" type="submit"
          style="font-size: 16px">
          <i class="fa fa-lock" aria-hidden="true"></i>
          Update Password
        </button>
      </div>
      <div *ngIf="!isValid" class="alert text-danger error">
        {{ submissionError }}
      </div>
      <div *ngIf="infoMessage">
        <p class="text-success">{{ infoMessage }}</p>
      </div>
    </form>
    <app-loading *ngIf="submitted"></app-loading>
  </div>
</div>

<section  *ngIf='passwordtype'>
  <div class="row">
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div class="card my-5">
        <div class="card-body">
          <h5 class="card-title text-center">Update Password</h5>

          <form class="my-3" [formGroup]="ChangePasswordConfirmForm" (ngSubmit)="UserChangePasswordConfirm()"
            novalidate>
            <div class="form-group">
              <div class="form-group">
                <mat-form-field appearance="legacy" style="font-size: 16px">
                  <mat-label>Old Password</mat-label>
                  <input type="password" matInput formControlName="oldpassword" placeholder="Old Password"
                    name="oldpassword" [ngClass]="{
                      'is-invalid': submitted && formControls2.oldpassword.errors
                    }" [type]="hide ? 'password' : 'text'" />
                  <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer">{{ hide ? "visibility_off" :
                    "visibility" }}
                  </mat-icon>
                  <mat-error *ngIf="formControls2.oldpassword.errors" class="invalid-feedback error">
                    <div *ngIf="formControls2.oldpassword.errors.required">
                      Password is <strong>required</strong>
                    </div>
                    <div *ngIf="formControls2.oldpassword.errors.pattern">
                      Password should be at least 8 characters including 1 number, 1 uppercase, 1 lowercase character
                      and
                      1 special character.
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="legacy" style="font-size: 16px">
                  <mat-label>New Password</mat-label>
                  <input type="password" matInput formControlName="newpassword" placeholder="New Password"
                    name="newpassword" [ngClass]="{
                    'is-invalid': submitted && formControls2.newpassword.errors
                  }" [type]="hide ? 'password' : 'text'" />
                  <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer">{{ hide ? "visibility_off" :
                    "visibility" }}
                  </mat-icon>
                  <mat-error *ngIf="formControls2.newpassword.errors" class="invalid-feedback error">
                    <div *ngIf="formControls2.newpassword.errors.required">
                      Password is <strong>required</strong>
                    </div>
                    <div *ngIf="formControls2.newpassword.errors.pattern">
                      Password should be at least 8 characters including 1 number, 1 uppercase, 1 lowercase character
                      and
                      1 special character.
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="legacy" style="font-size: 16px">
                  <mat-label>Confirm New Password</mat-label>
                  <input type="password" matInput formControlName="confirmnewpassword"
                    placeholder="Confirm New Password" name="confirmnewpassword" [ngClass]="{
                        'is-invalid': submitted && formControls2.confirmnewpassword.errors
                      }" [type]="hide ? 'password' : 'text'" />
                  <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer">{{ hide ? "visibility_off" :
                    "visibility" }}
                  </mat-icon>
                  <mat-error *ngIf="formControls2.confirmnewpassword.errors" class="invalid-feedback error">
                    <div *ngIf="formControls2.confirmnewpassword.errors.required">
                      Password is <strong>required</strong>
                    </div>
                    <div *ngIf="formControls2.confirmnewpassword.errors.pattern">
                      Password should be at least 8 characters including 1 number, 1 uppercase, 1 lowercase character
                      and
                      1 special character.
                    </div>
                    <div *ngIf="ChangePasswordConfirmForm.get('confirmnewpassword')?.hasError('passwordMismatch')">
                      Confirm password must match the new password.
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="form-group ">
            <button [disabled]="!ChangePasswordConfirmForm.valid || submitted" mat-raised-button color="accent"
              type="submit" style="font-size: 16px">
             Reset Password
            </button>
            </div>
            <div *ngIf="changePasswordError">
              <p class="text-danger mx-3">{{ changePasswordError }}</p>
            </div>
            <!-- <div *ngIf="!isValid" class="alert text-danger error">
              {{ submissionError }}
            </div> -->
          </form>
          <app-loading *ngIf="submitted"></app-loading>
        </div>
      </div>
     
    </div>
  </div>

</section>